'use strict'

import {promiseAllScripts, getUnloadedScripts} from './helpers/scriptLoader'

/**
 * Lazyloads owl scripts
 */
export function initOwlCarousel(callback){
    if('requestIdleCallback' in window){
        window.requestIdleCallback(function(){
            return promiseAllScripts(getUnloadedScripts('.js-async-owl'), callback);
        })
    }
    else {
        window.addEventListener('load', function(){
            return promiseAllScripts(getUnloadedScripts('.js-async-owl'), callback);
        })
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/performance/owl.js